<img src="../../../assets/images/smartphone-blocked.svg" alt="" />

<h2>Smartphones are not currently supported.</h2>

<app-further-assistance [showDefaultClientInfo]=true></app-further-assistance>
